var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "modal-box" }, [
      _c(
        "div",
        { staticStyle: { "margin-top": "-19rem" } },
        [
          _c(
            "div",
            {
              staticClass:
                "content-row content-align-center content-row-between modal-head"
            },
            [
              _c(
                "span",
                { staticClass: "font-24", staticStyle: { color: "#b2b2b2" } },
                [_vm._v(_vm._s(_vm.modalInfo.name))]
              ),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "back-btn font-24",
                  on: { click: _vm.hideModal }
                },
                [_vm._v(_vm._s(_vm.$t("return")))]
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "content-row modal-risk-box" }, [
            _c(
              "div",
              {
                staticClass: "content-row content-row-around",
                staticStyle: {
                  "padding-top": ".8rem",
                  background: "#cbe7ff",
                  "border-radius": ".3rem",
                  width: "23.9rem"
                }
              },
              [
                _c("div", {
                  staticClass: "compare-img",
                  attrs: { id: "modalBody" }
                }),
                _vm._v(" "),
                _c("img", {
                  staticClass: "compare-img",
                  attrs: { src: _vm.getRiskImg(_vm.modalInfo) }
                })
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "padding-right": ".67rem",
                  "padding-left": "1.35rem",
                  "flex-grow": "1",
                  height: "40px"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "riskipad content-row content-align-center content-row-between"
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "font-24",
                        staticStyle: {
                          color: "#474747",
                          "margin-right": ".5rem"
                        }
                      },
                      [_vm._v(_vm._s(_vm.modalInfo.name))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "font-22",
                        staticStyle: {
                          "margin-right": ".5rem",
                          color: "#8d8d8d"
                        }
                      },
                      [_vm._v(_vm._s(_vm.modalInfo.detail))]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        class:
                          "modal-level-box  " +
                          _vm.getLevel(_vm.modalInfo.level).className +
                          " font-242"
                      },
                      [
                        _vm.getLevel(_vm.modalInfo.level).des === "高风险"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("heightRisk")))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getLevel(_vm.modalInfo.level).des === "潜在风险"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("potentialRisk")))])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.getLevel(_vm.modalInfo.level).des === "正常"
                          ? _c("p", [_vm._v(_vm._s(_vm.$t("normal")))])
                          : _vm._e()
                      ]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row content-align-end",
                    staticStyle: { height: "3.1rem" }
                  },
                  [
                    _c("canvas", {
                      staticClass: "risk-bar",
                      attrs: {
                        "data-value": _vm.modalInfo.value,
                        "data-level": _vm.modalInfo.level,
                        id: "modalRiskBar"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "content-row content-row-between font-20 gmnClass riskipad",
                    staticStyle: { width: "auto", padding: "0 .5rem 0 .5rem" }
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "content-row font-18",
                    staticStyle: { "margin-top": "1.1rem", "flex-wrap": "wrap" }
                  },
                  _vm._l(_vm.modalInfo.risks, function(key) {
                    return _c("span", { staticClass: "key-box" }, [
                      _vm._v(_vm._s(key.name))
                    ])
                  }),
                  0
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content-row content-row-column content-align-start",
              staticStyle: {
                "margin-top": ".5rem",
                "background-color": "#fff",
                padding: "1.2rem 1.75rem"
              }
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-align-center font-20 risk-head auto-width",
                  staticStyle: { "margin-bottom": ".6rem" }
                },
                [
                  _c("span", { staticClass: "potentialRisk-icon" }),
                  _vm._v(" "),
                  _c("span", { staticStyle: { color: "#ff4d4d" } }, [
                    _vm._v(_vm._s(_vm.$tc("potentialRisk")))
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.modalInfo.risks, function(key) {
            return _c(
              "div",
              {
                staticClass: "col-md-6 col-xs-6 col-sm-6 col-lg-6",
                staticStyle: {
                  "background-color": "#fff",
                  height: "7.5rem",
                  float: "left",
                  padding: "0 1.75rem 0 3rem"
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "font18",
                    staticStyle: { "font-weight": "bold", color: "#474747" },
                    attrs: { id: "risk-des" }
                  },
                  [_vm._v(_vm._s(key.name))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "font-18",
                    staticStyle: {
                      color: "#898989",
                      "padding-left": "1rem",
                      "margin-top": ".9rem"
                    }
                  },
                  [_c("ul", [_c("li", [_vm._v(_vm._s(key.des))])])]
                )
              ]
            )
          })
        ],
        2
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-center close-box"
      },
      [_c("span", { staticClass: "close-btn", on: { click: _vm.hideModal } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-756c5e63", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-756c5e63","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_modal_ipad.vue
// module id = null
// module chunks = 